export const AUTH_BASE = "/auth";
export const LOGIN = "/auth/login";
export const SIGN_UP = "/signup";
export const FORGOT_PASSWORD = "/auth/password/email";
export const VERIFY_TOKEN = "auth/password/reset/";
export const RESET_PASSWORD = "/auth/password/reset/";
